<template>
  <div class="space-between-y">
    <!-- 搜索 -->
    <el-input placeholder="请输入关键词搜索" style="width: 200px" v-model="form.key"></el-input>

    <el-table :data="list?.filter(item => utils.string.search(JSON.stringify(item), form.key))" border stripe
              max-height="600">
      <el-table-column width="60" prop="id" label="id"></el-table-column>
      <el-table-column prop="name" label="name"></el-table-column>
      <el-table-column prop="type" label="type"></el-table-column>
      <el-table-column prop="codename" label="codename"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import {utils} from "@/util/utils";
import {access} from "@/api/access";

export default {
  name: 'AccessV1',
  computed: {
    utils() {
      return utils
    }
  },

  data() {
    return {
      list: [],

      form: {
        key: "",
      },


    };
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      access.listAll().then(list => {
        this.list = list;
      })
    },
  },

};
</script>

<style scoped>
</style>
